import React from 'react';
import {
  Select,
} from 'antd';
import FormModal from '../../../../common/FormModal';

const { Option } = Select;

const SubCategoryFormModal = ({ ...props }) => (
  <FormModal
    {...props}
    formItems={[
      {
        key: 'title',
        label: 'Title',
        rules: [{ required: true, message: 'Please input title!' }],
      },
      {
        key: 'status',
        label: 'Status',
        rules: [{ required: true, message: 'Please Story status!' }],
        Component: (
          <Select size='large' placeholder='select status'>
            <Option value>Active</Option>
            <Option value={false}>Blocked</Option>
          </Select>
        ),
      },
    ]}
  />
);
export default SubCategoryFormModal;
